import React, { useEffect } from 'react';
import { Button, ExceliconColorIcon, useSnackbar } from 'ui-components';

import { useExportToCSV } from './useExportToCSV';

interface Props {
  listId: string;
  fullWidth?: boolean;
  handleSuccess?: () => void;
}

export const ExportToCSV: React.FC<Props> = ({
  listId,
  fullWidth,
  handleSuccess,
}: Props) => {
  const exportToCSV = useExportToCSV(listId);
  const snackbar = useSnackbar();

  const handleExport = () => {
    exportToCSV.mutate();
  };

  useEffect(() => {
    if (exportToCSV.isError) {
      snackbar.error({
        description: 'There was an error exporting the CSV',
        duration: 9000,
        isCloseable: true,
      });
    }
  }, [exportToCSV.isError, snackbar]);

  useEffect(() => {
    if (exportToCSV.isSuccess) {
      handleSuccess?.();
    }
  }, [exportToCSV.isSuccess, handleSuccess]);

  return (
    <Button
      aria-label="Export .csv"
      variant="tertiary"
      leftIcon={<ExceliconColorIcon />}
      onClick={handleExport}
      isLoading={exportToCSV.isLoading}
      className={fullWidth ? 'w-full' : 'w-1/2'}
      trackId="foam-list-export-csv"
    >
      .csv
    </Button>
  );
};
